import Vue from 'vue'
import App from './App.vue'
import config from "./config"


console.log(config)
Vue.config.productionTip = false

//Vue.config = config;

new Vue({
  render: h => h(App),
}).$mount('#app')
